'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var log = require('debug')('ipfs');

var mergeOptions = require('merge-options');

var _require = require('ipfs-utils/src/env'),
    isTest = _require.isTest;

var globSource = require('ipfs-utils/src/files/glob-source');

var urlSource = require('ipfs-utils/src/files/url-source');

var _require2 = require('buffer'),
    Buffer = _require2.Buffer;

var PeerId = require('peer-id');

var PeerInfo = require('peer-info');

var crypto = require('libp2p-crypto');

var isIPFS = require('is-ipfs');

var multiaddr = require('multiaddr');

var multihash = require('multihashes');

var multibase = require('multibase');

var multicodec = require('multicodec');

var multihashing = require('multihashing-async');

var CID = require('cids');

var _require3 = require('./errors'),
    NotInitializedError = _require3.NotInitializedError;

var Components = require('./components');

var ApiManager = require('./api-manager');

var getDefaultOptions = function getDefaultOptions() {
  return {
    init: true,
    start: true,
    EXPERIMENTAL: {},
    preload: {
      enabled: !isTest,
      // preload by default, unless in test env
      addresses: ['/dns4/node0.preload.ipfs.io/https', '/dns4/node1.preload.ipfs.io/https', '/dns4/node2.preload.ipfs.io/https', '/dns4/node3.preload.ipfs.io/https']
    }
  };
};

function create(_x) {
  return _create.apply(this, arguments);
}

function _create() {
  _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options) {
    var print, apiManager, _apiManager$update, api;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = mergeOptions(getDefaultOptions(), options); // eslint-disable-next-line no-console

            print = options.silent ? log : console.log;
            apiManager = new ApiManager();
            _apiManager$update = apiManager.update({
              init: Components.init({
                apiManager: apiManager,
                print: print,
                options: options
              }),
              dns: Components.dns(),
              isOnline: Components.isOnline({})
            }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      throw new NotInitializedError();

                    case 1:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }))), api = _apiManager$update.api; // eslint-disable-line require-await

            if (options.init) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", api);

          case 6:
            _context2.next = 8;
            return api.init();

          case 8:
            if (options.start) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return", api);

          case 10:
            return _context2.abrupt("return", api.start());

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _create.apply(this, arguments);
}

module.exports = {
  create: create,
  crypto: crypto,
  isIPFS: isIPFS,
  Buffer: Buffer,
  CID: CID,
  multiaddr: multiaddr,
  multibase: multibase,
  multihash: multihash,
  multihashing: multihashing,
  multicodec: multicodec,
  PeerId: PeerId,
  PeerInfo: PeerInfo,
  globSource: globSource,
  urlSource: urlSource
};